import ApiService from "./ApiService";

let cachedPromise = null;

/** Drop cache so the next call refetches (e.g. after logout or env switch). */
export function clearSysCredentialsCache() {
    cachedPromise = null;
}

/**
 * GET /home/sys/credentials — single-flight cached.
 * Shape includes region, bucketEndpoint, accessKey, accessSecret, revenueCat, etc.
 */
export async function getSysCredentials() {
    if (!cachedPromise) {
        cachedPromise = ApiService.getData("/home/sys/credentials").catch((err) => {
            cachedPromise = null;
            throw err;
        });
    }
    return cachedPromise;
}

function trimOrEmpty(v) {
    if (v == null) return "";
    const s = String(v).trim();
    return s;
}

/**
 * RevenueCat Apple public SDK key (credentials.revenueCat.apiKey, e.g. appl_…).
 * Falls back to REACT_APP_REVENUECAT_APPLE_APP_KEY for local/dev if present.
 */
export async function getRevenueCatApiKey() {
    try {
        const c = await getSysCredentials();
        const fromApi = trimOrEmpty(c?.revenueCat?.apiKey);
        if (fromApi) return fromApi;
    } catch {
        /* fall through */
    }
    return trimOrEmpty(process.env.REACT_APP_REVENUECAT_APPLE_APP_KEY);
}
